const Version = (props) => {
  return (
    <div id="version">v1.1.0</div>
  )
}

export default Version
